import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Stuhome from "./components/Student/Stuhome";
import Industryhome from "./components/Industry/Industryhome";
import Studentsignup from "./components/Student/Studentsignup";
import Studentlogin from "./components/Student/Studentlogin";
import Industrysignup from "./components/Industry/Industrysignup";
import Industrylogin from "./components/Industry/Industrylogin";
import StudentForm from "./components/Student/StudentForm";
// import PrivateRoute from "./components/PrivateRoute";
import Stuprofile from "./components/Student/Stuprofile";
import AuthProvider from "./components/context/auth";
import Industryprofile from "./components/Industry/Industryprofile";
import Industryform from "./components/Industry/Industryform";
import Postjob from "./components/Industry/Postjob";
import Tnplogin from "./components/Tnp/Tnplogin";
import Tnphome from "./components/Tnp/Tnphome";
import Error from "./pages/Error";
import Companydetails from "./components/Tnp/Companydetails";

import Displayapplied from "./components/Industry/Displayapplied";
import DashmiuBoard from "./components/Student/DashmiuBoard";
import Viewstudetails from "./components/Industry/Viewstudetails";
import Viewindustry from "./components/Student/Viewindustry";
import Studetails from "./components/Tnp/Studetails";
import SortedByClass from "./components/Tnp/SortedByClass";
import Sortedbydepart from "./components/Tnp/Sortbydepart";


function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/studentlogin" element={<Studentlogin />} />
          <Route path="/studentsignup" element={<Studentsignup />} />
          <Route path="/industrysignup" element={<Industrysignup />} />
          <Route path="/industrylogin" element={<Industrylogin />} />
          <Route path="/tnplogin" element={<Tnplogin />} />
          <Route path="/studentform" element={<StudentForm />} />
          <Route path="/industryform" element={<Industryform />} />
          <Route path="/stuhome" element={<Stuhome />} />
          <Route path="/tnphome" element={<Tnphome />} />
        
          <Route path="/companydetails" element={<Companydetails />} />
          <Route path="/displayapplied" element={<Displayapplied/>} />
          <Route path="/industryhome" element={<Industryhome />} />
          <Route path="/stuprofile" element={<Stuprofile />} />
          <Route path="/industryprofile" element={<Industryprofile />} />
          <Route path="/postjob" element={<Postjob />} />
          <Route path ="/dashboard" element={<DashmiuBoard/>} />
          <Route path ="/viewstudetails" element={<Viewstudetails/>} />
          <Route path ="/viewindustry" element={<Viewindustry/>} />
          <Route path ="/studetails" element={<Studetails/>} />
          <Route path ="/sortedbyclass" element={<SortedByClass/>} />
          <Route path ="/sortedbydepart" element={<Sortedbydepart/>} />
          <Route path="*" element={<Error />} />
         
          {/* <PrivateRoute exact path="/stuprofile" component={Stuprofile} />
          <PrivateRoute exact path="/stuhome" component={Stuhome} /> */}
          {/* <Route path='/industryhome' element={<PrivateRoute element={<Industryhome/>}/>}/> */}
          {/* <Route path='/stuprofile' element={<PrivateRoute element={<Stuprofile/>}/>}/> */}
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
